import { createContext, type SyntheticEvent } from 'react';

export type BalancePlusOnPress = (clickId: string) => (ev: SyntheticEvent<HTMLElement>) => void;

// Lets <Balance> render the store "+" button inside the SC pill (dual-balance mode)
// while the click handler stays owned by <BalancePanel>.
export const BalancePlusContext = createContext<BalancePlusOnPress | null>(null);
